import React from "react"
import { reduxForm } from "redux-form"
import { COLOR, JARGON } from "../modules/constants"

import CircularProgress from "@mui/material/CircularProgress"

const DeleteAccountConfirmForm = ({ handleSubmit, cancelDelete, submitting }) => {
  return (
    <form onSubmit={handleSubmit}>
      <p>
        Are you sure you want to {JARGON.DELETE.toLowerCase()} all your reports and close your Numerable account? This step cannot be undone.
      </p>
      <div className="button_group">

        <button type="button" className="button" disabled={submitting} onClick={cancelDelete}
          style={{ background: COLOR.BRAND.STD, marginRight: "20px" }}
        >Cancel</button>

        <button type="submit" className="button" disabled={submitting}
          style={{ background: COLOR.BRAND.STD }}
        >
          {submitting ? <CircularProgress size={24} /> : "Confirm"}
        </button>
      </div>
    </form>
  )
}

export default reduxForm({ form: "deleteAccountConfirm" })(DeleteAccountConfirmForm)